import {
  Component,
  HostBinding,
  Input,
  InputSignal,
  WritableSignal,
  inject,
  input,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BaseWidget } from '@app/widgets/base-widget/base-widget';
import { ViewType } from '@app/core/enums/widget/view-type.enum';
import { PipeModule } from '@app/core/pipe/pipe.module';
import { ProgressBarComponent } from '@app/widgets/progress-bar/progress-bar.component';
@Component({
  selector: 'product-detail-specification',
  standalone: true,
  imports: [
    MatTabsModule,
    CommonModule,
    NgOptimizedImage,
    PipeModule,
    ProgressBarComponent,
  ],
  templateUrl: './product-detail-specification.component.html',
  styleUrl: './product-detail-specification.component.scss',
})
export class ProductDetailSpecificationComponent extends BaseWidget {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  public slot: InputSignal<any> = input();
  productData: WritableSignal<any> = signal(null);

  slotData = signal(null);
  data: { slot: any; viewType: string };
  showTable: WritableSignal<boolean> = signal(false);

  isPopup: WritableSignal<boolean> = signal(false);

  private readonly dialogRef?: MatDialogRef<ProductDetailSpecificationComponent> =
    inject(MatDialogRef, { optional: true });

  protected readonly dialogData?: { slot: any; viewType: string } = inject(
    MAT_DIALOG_DATA,
    { optional: true },
  );

  ngOnInit(): void {
    this.data = this.dialogData;
    if (this.data?.viewType === ViewType.POPUP) {
      this.isPopup.set(true);
      this.showTable.set(true);
      this.slotData.set(this.data.slot);
    } else {
      this.slot()?.widget?.viewType === ViewType.PDP_DESCRIPTION_WIDGET
        ? this.showTable.set(true)
        : this.showTable.set(false);
      this.slotData.set(this.slot());
    }
    if (this.slotData()?.widget?.data?.value) {
      const { description, specifications } =
        this.slotData()?.widget?.data?.value?.data;
      const updateData: {
        description?: string;
        specifications?: { [key: string]: string };
      } = {};
      if (specifications) updateData.specifications = specifications;
      if (description) updateData.description = description;
      this.productData.set(updateData);
    }
  }
  keepOriginalOrder = () => 0;
  popupClose() {
    this.dialogRef?.close();
  }
}
